import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth'; // GoogleAuthProvider eklendi
import { getStorage, ref, getDownloadURL } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDOZO1NNXuT-NlHkjEIse_TnMpfruZLm70",
  authDomain: "ayzplastik-f4f7d.firebaseapp.com",
  projectId: "ayzplastik-f4f7d",
  storageBucket: "ayzplastik-f4f7d.firebasestorage.app",
  messagingSenderId: "217687476327",
  appId: "1:217687476327:web:e12429475b04f2f7df2cc2"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider(); // Google motorunu dışa aktarıyoruz
export const storage = getStorage(app);

// Google girişi için ufak bir ayar (isteğe bağlı: otomatik hesap seçiciyi tetikler)
googleProvider.setCustomParameters({ prompt: 'select_account' });

// --- Resim Çözümleme Cache Sistemi ---
const imageCache = new Map();
let storageAccessible = null;

export async function resolveImageUrl(filename) {
  if (!filename) return null;
  if (filename.startsWith('http')) return filename;
  if (imageCache.has(filename)) return imageCache.get(filename);
  if (storageAccessible === false) {
    imageCache.set(filename, null);
    return null;
  }

  try {
    const imageRef = ref(storage, filename);
    const url = await getDownloadURL(imageRef);
    storageAccessible = true;
    imageCache.set(filename, url);
    return url;
  } catch (err) {
    if (storageAccessible === null) {
      storageAccessible = false;
      console.log('Firebase Storage erişim izni yok. Rules bölümünden "allow read" ekleyin.');
    }
    imageCache.set(filename, null);
    return null;
  }
}

// --- Ürün Verisi Normalizasyonu ---
export function normalizeProduct(doc) {
  const data = doc.data ? doc.data() : doc;
  const id = doc.id || data.id;

  if (data.isim) {
    return {
      id,
      name: data.isim || '',
      price: data.fiyat || 0,
      images: Array.isArray(data.resim) ? data.resim : [],
      features: Array.isArray(data.ozellikler) ? data.ozellikler : [],
      description: data.aciklama || data.description || '',
      category: data.kategori || data.category || '',
      createdAt: data.created_at || data.createdAt || '',
      _raw: data,
    };
  }

  return {
    id,
    name: data.name || data.title || '',
    price: data.price || 0,
    images: data.image_url ? [data.image_url] : (data.imageUrl ? [data.imageUrl] : []),
    features: Array.isArray(data.features) ? data.features : [],
    description: data.description || '',
    category: data.category || '',
    specifications: Array.isArray(data.specifications) ? data.specifications : [],
    createdAt: data.created_at || data.createdAt || '',
    _raw: data,
  };
}

export default app;